import $ from "jquery";
import * as Common from "../../../../common/common";

export default function standart() {}

export const fillDetail = () => {
  var test = window.$catalog_management_units_selectedRow;
  $("#algemeenNaam").html(
    window.$catalog_management_units_selectedRow.algemeenNaam
  );
  $("#algemeenNaam-tooltip").html(
    window.$catalog_management_units_selectedRow.algemeenNaam
  );
  $("#algemeenCode").html(
    window.$catalog_management_units_selectedRow.algemeenCode
  );
  $("#endDate").attr(
    "placeholder",
    window.$catalog_management_units_selectedRow.endDate
  );
  $("#startDate").attr(
    "placeholder",
    window.$catalog_management_units_selectedRow.startDate
  );
  if (window.$catalog_management_units_selectedRow.isActive)
    $("#beheereenheid_active").attr("checked", "checked");
  else $("#beheereenheid_active").removeAttr("checked");

  //editSide
  $("#e-algemeenNaam").val(
    window.$catalog_management_units_selectedRow.algemeenNaam
  );
  $("#e-algemeenCode").val(
    window.$catalog_management_units_selectedRow.algemeenCode
  );
  $("#e-identification").val(
    window.$catalog_management_units_selectedRow.identification
  );

  if (window.$catalog_management_units_selectedRow.isActive)
    $("#e-beheereenheid_active").attr("checked", "checked");
  else $("#e-beheereenheid_active").removeAttr("checked");
  var startDate = String(
    window.$catalog_management_units_selectedRow.startDate.replaceAll("-", "/")
  );
  startDate =
    startDate.split("/")[1] +
    "/" +
    startDate.split("/")[0] +
    "/" +
    startDate.split("/")[2];
  var endDate = String(
    window.$catalog_management_units_selectedRow.endDate.replaceAll("-", "/")
  );
  endDate =
    endDate.split("/")[1] +
    "/" +
    endDate.split("/")[0] +
    "/" +
    endDate.split("/")[2];
  startDate = new Date(startDate);
  endDate = new Date(endDate);

  document.getElementById("e-startDate").value = Common.FormatDateReverse(
    startDate,
    "date"
  );
  document.getElementById("e-endDate").value = Common.FormatDateReverse(
    endDate,
    "date"
  );
  $("#e-endDate").attr("min", Common.FormatDateReverse(startDate, "date"));
};
